<template>
  <div class="div-container">
    <div class="fast item" :class="{ 'active': active == 'fast' && isPC }" @mouseenter="chooseItem('fast')">
      <div class="title">
        <div class="main main-fast">超快充电</div>
        <div class="sub" v-if="isPC">14分钟，完成30%至80%的充电<span style="font-size: 0.8vw;opacity: 0.8;">（*以350KW超快充电桩为准）</span></div>
        <div class="sub sub-mob" v-else>
          <div>14分钟，完成30%至80%的充电</div>
          <div style="font-size: 5px;opacity: 0.8;line-height: 1.3;margin-top: 5px;">* 以350KW超快充电桩为准</div>
          <div style="font-size: 5px;opacity: 0.8;line-height: 1.3;">※ 以上电池充电时间是基于我公司研究所试验结果的数值 </div>
          <div style="font-size: 5px;opacity: 0.8;line-height: 1.3;">※ 以上充电速度是在常温条件下的电池温度/车外温度下测量的数值，实际充电速度会因电池温度、充电功率、电池劣化程度、车外温度等而有所不同  </div>
          <div style="font-size: 5px;opacity: 0.8;line-height: 1.3;">※ 冬季等车外温度偏低环境下，实际充电时间可能会因电池性能下降而增加</div>
          <div style="font-size: 5px;opacity: 0.8;line-height: 1.3;">※ 画面中车型图片仅供参考，具体以当地授权经销商店内实际销售车型为准 </div>
        </div>
      </div>
      <div class="tips" v-if="!isPortrait">
        <!-- <div>*以上电池充电速度是在常温条件下电池/车外温度下测量的数值，实际充电速度受其他因素影响而有所不同</div> -->
        <div>※ 以上电池充电时间是基于我公司研究所试验结果的数值 </div>
        <div>※ 以上充电速度是在常温条件下的电池温度/车外温度下测量的数值，实际充电速度会因电池温度、充电功率、电池劣化程度、车外温度等而有所不同  </div>
        <div>※ 冬季等车外温度偏低环境下，实际充电时间可能会因电池性能下降而增加 </div>
        <div>※ 画面中车型图片仅供参考，具体以当地授权经销商店内实际销售车型为准 </div>
      </div>
    </div>
    <div class="long item" :class="{ 'active': active == 'long' && isPC }" @mouseenter="chooseItem('long')">
      <div class="title">
        <div class="main main-long">超长续航</div>
        <div class="sub">EV6的76.4kWh大容量电池，一次充电续航里程最大可达671公里</div>
        <div class="sub sub-mob" v-if="isPortrait">
          <div style="font-size: 5px;opacity: 0.8;line-height: 1.3;">※ 以上能耗（续航里程）以产业部认证数值为准</div>
          <div style="font-size: 5px;opacity: 0.8;line-height: 1.3;">※ 以上能耗（续航里程）是基于标准模式的数值，实际情况可能因驾驶方式、车速、搭乘人数、载重量、车辆设置、 保养状态、车外温度、天气情况及路况等而有所差异</div>
          <div style="font-size: 5px;opacity: 0.8;line-height: 1.3;">※ 冬季等车外温度偏低环境下，实际续航里程可能会因电池性能下降而缩短</div>
          <div style="font-size: 5px;opacity: 0.8;line-height: 1.3;">※ 画面中车型图片仅供参考，具体以当地授权经销商店内实际销售车型为准</div>
        </div>
      </div>
      <div class="tips" v-if="!isPortrait">
        <div>※ 以上能耗（续航里程）以产业部认证数值为准</div>
        <div>※ 以上能耗（续航里程）是基于标准模式的数值，实际情况可能因驾驶方式、车速、搭乘人数、载重量、车辆设置、 保养状态、车外温度、天气情况及路况等而有所差异</div>
        <div>※ 冬季等车外温度偏低环境下，实际续航里程可能会因电池性能下降而缩短</div>
        <div>※ 画面中车型图片仅供参考，具体以当地授权经销商店内实际销售车型为准</div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { isPortraitFun, getUrlKey, isPc, maidian } from "@/utils/utils.js";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      isPC: isPc(),
      active: "fast",
    };
  },
  mounted: function () {
    let that = this;
  },
  methods: {
    chooseItem(item) {
      if (!this.isPC) {
        return
      }
      this.active = item
      let name = '超快充电'
      if (item=="long") {
        name = '超长续航'
      }
      maidian("FastAndLong-" + name)
    }
  },
};
</script>

<style lang="scss" scoped>
.div-container {
  width: 100%;
  height: 46.1458vw;
  cursor: pointer;
  display: flex;

  .item {
    width: 33.75%;
    height: 100%;
    background-size: auto 100%;
    background-position: center center;
    background-repeat: no-repeat;
    transition: all .4s;
    position: relative;
    color: #fff;
    position: relative;

    &.fast {
      background-image: url('https://www.kia.cn/assets/~/media/images/vehicle/ev6/fast-long/fast.png');
    }

    &.long {
      background-image: url('https://www.kia.cn/assets/~/media/images/vehicle/ev6/fast-long/long.png');
    }

    .title {
      position: absolute;
      left: 12%;
      top: 72%;

      .main {
        font-family: chuhei;
        font-size: 1.6666vw;
        width: 6.8vw;
        /* height: 2.4958vw; */
        line-height: 2.4vw;
        /* padding-bottom: 0.83vw; */
        border-bottom: 3px solid #fff;
        transition: all .4s;
        overflow: hidden;
        /* &-fast {
          width: 6.8vw;
        }
        &-long {
          width: 6.8vw;
        } */
      }

      .sub {
        width: 0;
        margin-top: 7px;
        height: 1.7708vw;
        font-size: 1.25vw;
        transition: all .4s;
        overflow: hidden;
      }
    }

    .tips {
      transition: all .4s;
      opacity: 0;
      position: absolute;
      /* width: */
      top: 84%;
      left: 12%;
      width: 75.5%;
      font-size: 0.8vw;
    }

    &.active {
      width: 66.25%;

      .main {
        border-bottom: 3px solid rgba($color: #fff, $alpha: 0);

        &-fast {
          width: 37.21vw;
        }

        &-long {
          width: 32vw;
        }
      }

      .sub {
        width: 100%;
      }

      .tips {
        opacity: 0.8;
      }
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    display: block;

    .item {
      width: 100%;
      height: 100vw;

      &.fast {
        background-position: 15%;
      }

      .title {
        width: 100%;
        height: auto;
        top: unset;
        bottom: 15px;
        left: 0;
        padding: 0 20px;

        .main {
          width: auto;
          border: none;
          font-size: 20px;
          font-weight: 600;
          line-height: 26px;
        }

        .sub {
          width: auto;
          height: auto;
          font-size: 18px;
          line-height: 26px;
        }
      }
    }
  }
}
</style>
